export interface SeoContent {
  heading: string | undefined;
  pageTitle: string | undefined;
  metaDescription: string | undefined;
  index: boolean | undefined;
  follow: boolean | undefined;
  blurbHeading: string | undefined;
  blurb: string | undefined;
  faqs: Faq[] | undefined;
  interlinks: LinksGroupItem[] | undefined;
}

export interface Faq {
  question?: string;
  answer?: string;
}

export interface Link {
  title: string;
  url: string;
}

export interface ContentfulLinksGroupItem {
  key?: string;
  heading?: string;
  links?: {
    json?: any;
  };
}
export interface BasicLinksGroupItem {
  key: string;
  heading: string;
  links: Link[];
}

export type LinksGroupItem = BasicLinksGroupItem | ContentfulLinksGroupItem;

export function isBasicLinksGroupItem(
  item: LinksGroupItem,
): item is BasicLinksGroupItem {
  return Array.isArray((item as BasicLinksGroupItem).links);
}

export interface SeoApiResponse {
  indexed: boolean;
  priorityInterlinks: BasicLinksGroupItem[];
}
